import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseTextFields from "../Datasources/DatasourceBaseTextFields.jsx";


const DatasourceKleos = (props) => {

        const Fields = [
            {Identifier:"ClientID", Translation:Translate("Client ID"), Required:true},
            {Identifier:"ClientSecret", Translation:Translate("Client secret"), Required:true}
        ]
        
        return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)
    
}

DatasourceKleos.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceKleos